module.exports = "https://static.wmbcdn.com/uniweb/images/ce794d492955c234a7e31801c7136e4c.svg";